import React from 'react';
import { motion } from 'framer-motion';

const Vision = () => {
  return (
    <section className="py-40 px-4 border-t border-white/5 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-purple-900/20" />
      
      <div className="max-w-5xl mx-auto text-center relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 1.2, ease: "easeOut" }}
        >
          <h2 className="text-4xl md:text-6xl font-serif italic mb-10 text-transparent bg-clip-text bg-gradient-to-r from-purple-300 via-pink-300 to-purple-300 tracking-wide">
            Transformation through Energy
          </h2>
          
          <div className="w-24 h-1 bg-gradient-to-r from-transparent via-purple-500 to-transparent mx-auto mb-12 opacity-50" />
          
          <p className="text-2xl md:text-4xl text-slate-300 leading-relaxed font-light max-w-4xl mx-auto">
            DAI KHO LIMITED brand philosophy: 
            <br />
            <span className="text-white font-bold italic tracking-tight">"From great suffering can one achieve great enlightenment."</span>
            <br className="hidden md:block" />
            <br className="hidden md:block" />
            <span className="text-slate-400 text-xl md:text-2xl">
              Our ecosystem serves as the bridge between personal growth, 
              community identity, and verifiable real-world impact.
            </span>
          </p>
        </motion.div>
      </div>
    </section>
  );
};

export default Vision;